"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountBridge = void 0;
const errors_1 = require("@ledgerhq/errors");
const bignumber_js_1 = require("bignumber.js");
const ledger_filecoin_1 = __importDefault(require("@zondax/ledger-filecoin"));
const rxjs_1 = require("rxjs");
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const jsHelpers_2 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const utils_1 = require("./utils/utils");
const api_1 = require("./utils/api");
const account_1 = require("../../../account");
const hw_1 = require("../../../hw");
const serializer_1 = require("./utils/serializer");
const utils_2 = require("../utils");
const logs_1 = require("@ledgerhq/logs");
const addresses_1 = require("./utils/addresses");
const operation_1 = require("../../../operation");
const deviceAccess_1 = require("../../../hw/deviceAccess");
const receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
const createTransaction = () => {
    // log("debug", "[createTransaction] creating base tx");
    return {
        family: "filecoin",
        amount: new bignumber_js_1.BigNumber(0),
        method: 0,
        version: 0,
        nonce: 0,
        gasLimit: new bignumber_js_1.BigNumber(0),
        gasFeeCap: new bignumber_js_1.BigNumber(0),
        gasPremium: new bignumber_js_1.BigNumber(0),
        recipient: "",
        useAllAmount: false,
    };
};
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    // log("debug", "[getTransactionStatus] start fn");
    const errors = {};
    const warnings = {};
    const { balance } = a;
    const { address } = (0, utils_1.getAddress)(a);
    const { recipient, useAllAmount, gasPremium, gasFeeCap, gasLimit } = t;
    let { amount } = t;
    if (!recipient)
        errors.recipient = new errors_1.RecipientRequired();
    else if (!(0, addresses_1.validateAddress)(recipient).isValid)
        errors.recipient = new errors_1.InvalidAddress();
    else if (!(0, addresses_1.validateAddress)(address).isValid)
        errors.sender = new errors_1.InvalidAddress();
    if (gasFeeCap.eq(0) || gasPremium.eq(0) || gasLimit.eq(0))
        errors.gas = new errors_1.FeeNotLoaded();
    // This is the worst case scenario (the tx won't cost more than this value)
    const estimatedFees = (0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit);
    let totalSpent;
    if (useAllAmount) {
        totalSpent = a.spendableBalance;
        amount = totalSpent.minus(estimatedFees);
        if (amount.lte(0) || totalSpent.gt(balance)) {
            errors.amount = new errors_1.NotEnoughBalance();
        }
    }
    else {
        totalSpent = amount.plus(estimatedFees);
        if (amount.eq(0)) {
            errors.amount = new errors_1.AmountRequired();
        }
        else if (totalSpent.gt(a.spendableBalance))
            errors.amount = new errors_1.NotEnoughBalance();
    }
    // log("debug", "[getTransactionStatus] finish fn");
    return {
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    };
});
const estimateMaxSpendable = ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    // log("debug", "[estimateMaxSpendable] start fn");
    const a = (0, account_1.getMainAccount)(account, parentAccount);
    const { address } = (0, utils_1.getAddress)(a);
    const recipient = transaction === null || transaction === void 0 ? void 0 : transaction.recipient;
    if (!(0, addresses_1.validateAddress)(address).isValid)
        throw new errors_1.InvalidAddress();
    if (recipient && !(0, addresses_1.validateAddress)(recipient).isValid)
        throw new errors_1.InvalidAddress();
    const balances = yield (0, api_1.fetchBalances)(address);
    let balance = new bignumber_js_1.BigNumber(balances.spendable_balance);
    if (balance.eq(0))
        return balance;
    const amount = transaction === null || transaction === void 0 ? void 0 : transaction.amount;
    const result = yield (0, api_1.fetchEstimatedFees)({ to: recipient, from: address });
    const gasFeeCap = new bignumber_js_1.BigNumber(result.gas_fee_cap);
    const gasLimit = new bignumber_js_1.BigNumber(result.gas_limit);
    const estimatedFees = (0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit);
    if (balance.lte(estimatedFees))
        return new bignumber_js_1.BigNumber(0);
    balance = balance.minus(estimatedFees);
    if (amount)
        balance = balance.minus(amount);
    // log("debug", "[estimateMaxSpendable] finish fn");
    return balance;
});
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const { balance } = a;
    const { address } = (0, utils_1.getAddress)(a);
    const { recipient, useAllAmount } = t;
    if (recipient &&
        address &&
        (0, addresses_1.validateAddress)(recipient).isValid &&
        (0, addresses_1.validateAddress)(address).isValid) {
        const patch = {};
        const result = yield (0, api_1.fetchEstimatedFees)({ to: recipient, from: address });
        patch.gasFeeCap = new bignumber_js_1.BigNumber(result.gas_fee_cap);
        patch.gasPremium = new bignumber_js_1.BigNumber(result.gas_premium);
        patch.gasLimit = new bignumber_js_1.BigNumber(result.gas_limit);
        patch.nonce = result.nonce;
        const fee = (0, utils_2.calculateEstimatedFees)(patch.gasFeeCap, patch.gasLimit);
        if (useAllAmount)
            patch.amount = balance.minus(fee);
        return (0, jsHelpers_2.defaultUpdateTransaction)(t, patch);
    }
    return t;
});
const sync = (0, jsHelpers_1.makeSync)({ getAccountShape: utils_1.getAccountShape });
const broadcast = ({ signedOperation: { operation, signature } }) => __awaiter(void 0, void 0, void 0, function* () {
    // log("debug", "[broadcast] start fn");
    const tx = (0, utils_1.getTxToBroadcast)(operation, signature);
    const resp = yield (0, api_1.broadcastTx)(tx);
    const { hash } = resp;
    const result = (0, operation_1.patchOperationWithHash)(operation, hash);
    // log("debug", "[broadcast] finish fn");
    return result;
});
const signOperation = ({ account, deviceId, transaction, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => new rxjs_1.Observable(o => {
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            // log("debug", "[signOperation] start fn");
            const { recipient, method, version, nonce, gasFeeCap, gasLimit, gasPremium } = transaction;
            const { amount } = transaction;
            const { id: accountId } = account;
            const { address, derivationPath } = (0, utils_1.getAddress)(account);
            if (!gasFeeCap.gt(0) || !gasLimit.gt(0)) {
                (0, logs_1.log)("debug", `signOperation missingData --> gasFeeCap=${gasFeeCap} gasLimit=${gasLimit}`);
                throw new errors_1.FeeNotLoaded();
            }
            const filecoin = new ledger_filecoin_1.default(transport);
            try {
                o.next({
                    type: "device-signature-requested",
                });
                const fee = (0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit);
                // Serialize tx
                const serializedTx = (0, serializer_1.toCBOR)(account, transaction);
                (0, logs_1.log)("debug", `[signOperation] serialized CBOR tx: [${serializedTx.toString("hex")}]`);
                // Sign by device
                const result = yield filecoin.sign((0, utils_2.getPath)(derivationPath), serializedTx);
                (0, utils_2.isError)(result);
                o.next({
                    type: "device-signature-granted",
                });
                // resolved at broadcast time
                const txHash = "";
                // build signature on the correct format
                const signature = `${result.signature_compact.toString("base64")}`;
                const operation = {
                    id: (0, operation_1.encodeOperationId)(accountId, txHash, "OUT"),
                    hash: txHash,
                    type: "OUT",
                    senders: [address],
                    recipients: [recipient],
                    accountId,
                    value: amount.plus(fee),
                    fee,
                    blockHash: null,
                    blockHeight: null,
                    date: new Date(),
                    extra: {
                        gasLimit,
                        gasFeeCap,
                        gasPremium,
                        method,
                        version,
                        nonce,
                        signatureType: 1,
                    },
                };
                o.next({
                    type: "signed",
                    signedOperation: {
                        operation,
                        signature,
                        expirationDate: null,
                    },
                });
            }
            finally {
                (0, hw_1.close)(transport, deviceId);
                // log("debug", "[signOperation] finish fn");
            }
        });
    }
    main().then(() => o.complete(), e => o.error(e));
}));
exports.accountBridge = {
    createTransaction,
    updateTransaction: jsHelpers_2.defaultUpdateTransaction,
    prepareTransaction,
    getTransactionStatus,
    estimateMaxSpendable,
    sync,
    receive,
    broadcast,
    signOperation,
};
//# sourceMappingURL=account.js.map